import xs from "xstream"
import dropRepeats from "xstream/extra/dropRepeats"
import * as R from "ramda"
import Dexie from "dexie"
import { nopListener, dumper } from "../utils"

const DB_NAME = "app"
const DB_VERSION = 1

export enum LocalConfigCommand {
	Get, Set, Remove
}

export interface LocalConfig {
	command: LocalConfigCommand, 
	key: string,
	value?: any
}

export function makeLocalConfig() {
	const db: any = new Dexie(DB_NAME)

	db.version(DB_VERSION).stores({
		config: "key"
	})
	const config: any = db.config 
	const source$ = xs.create()
	return sink$ => {
		sink$
			.map(async (cfg: LocalConfig) => {
				if (cfg.command === LocalConfigCommand.Get) {
					const value = await config.get(cfg.key)
					source$.shamefullySendNext(R.mergeLeft({value}, cfg))
				} else if (cfg.command === LocalConfigCommand.Set) {
					const ret  = await config.put(cfg.value)
					source$.shamefullySendNext(cfg)

				} else if (cfg.command === LocalConfigCommand.Remove) {
					const ret  = await config.delete(cfg.key)
					source$.shamefullySendNext(cfg)
				}
			})
			// .addListener(dumper("localConfig"))
			.addListener(nopListener("localStorage"))

		return {
			select: (key: string) =>
				source$
					.filter(R.propEq(key, "key"))
					.map(R.prop("value"))
		}
	}
}
